import CalculateMarginUseCase from "@domains/features/Tools/MarginCalculator/useCases/CalculateMargin";
import SearchSymbolUseCase from "@domains/features/Tools/MarginCalculator/useCases/SearchSymbol";
import DerivativeDetailsUseCase from "@domains/features/Tools/MarginCalculator/useCases/DerivativeDetails";
import StrikePriceUseCase from "@domains/features/Tools/MarginCalculator/useCases/StrikePrice";
import ExpiryDateUseCase from "@domains/features/Tools/MarginCalculator/useCases/getExpirydate";
export default (repo) => {
    return {
        marginCalculator: {
            calculateMargin: new CalculateMarginUseCase(repo.marginCalculator),
            getSearchedSymbolData: new SearchSymbolUseCase(repo.marginCalculator),
            getDerivativeDetails: new DerivativeDetailsUseCase(repo.marginCalculator),
            getStrikePriceList: new StrikePriceUseCase(repo.marginCalculator),
            getExpirydate: new ExpiryDateUseCase(repo.expiryDates),
        },
    };
};
